import { StyleRules, TableCellClassKey } from "@material-ui/core";

export const MuiTableCell: Partial<StyleRules<TableCellClassKey, {}>> = {
  root: {
    fontSize: 16,
  },
};
